module.exports = __webpack_public_path__ + "media/packs/images/photo-b5fcc79d4a8762d4de2d0f92724b217c.jpg";